import { keys } from './keys';
import { query } from './query';
import { Component } from 'react';
import { v4 as uuid } from 'uuid';
import { withTranslation } from 'react-i18next';
import Timeline from '../../../../../components/Timeline';
import { colors } from '../../../../../lib/colors';
import CheckData from '../../../../../components/CatchError';
import { AI_TOOLS } from '../../../configs';

class BlockCitation extends Component {
    constructor() {
        super();

        this.getData = this.getData.bind(this);
        this.forceRun = this.forceRun.bind(this);

        this.state = {
            data: [],
            loading: true,
        };
    }

    async getData({ force = false, alreadyInQueue = false }) {
        try {
            this.query = query({
                prompt_uids: this.props.prompt_uids,
                platforms: this.props.platforms,
            });
            this.setState({ loading: true });

            this.query.bind(this.setState.bind(this));
            const results = await this.query.update({ force, alreadyInQueue });
            const data = results
                ?.filter((x) => x.platform !== 'grok')
                ?.map((x) => ({
                    id: uuid(),
                    ...x,
                    runsNolinks: x.totalRuns - x.runsLinks,
                }));
            this.setState({
                data,
                loading: false,
            });
        } catch (err) {
            console.log(err);
        }
    }

    forceRun() {
        this.getData({ force: true, alreadyInQueue: true });
    }

    async componentDidUpdate(prevProps) {
        if (
            !this.props.globalLoading &&
            this.props.globalLoading !== prevProps.globalLoading &&
            !this.props.prompt_uids?.length
        ) {
            this.setState({ data: [], loading: false });
        }

        if (
            JSON.stringify(prevProps.prompt_uids) !== JSON.stringify(this.props.prompt_uids) ||
            JSON.stringify(prevProps.platforms) !== JSON.stringify(this.props.platforms)
        ) {
            this.getData({});
        }

        if (this.props.updateAll !== prevProps.updateAll) {
            this.forceRun();
        }
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => item.brand?.toLowerCase().includes(search.toLowerCase()));
    }

    render() {
        const { t } = this.props;

        const chartData = (datasetIndex) => ({
            labels: this.state.data?.map((item) => AI_TOOLS[item.platform]),
            datasets: keys(t).map((item, i) => ({
                label: item?.label,
                type: item.type ?? 'line',
                data: this.state.data?.map((data) =>
                    item.render ? item.render(data[item.key]) : data[item.key],
                ),
                backgroundColor: [colors[i], colors[i]],
                borderColor:
                    datasetIndex === null || datasetIndex === i
                        ? colors[i]
                        : 'rgba(128, 128, 128, 0.2)',
                yAxisID: item.yAxisID ?? 'y',
                hidden: item.hidden ?? false,
                borderRadius: 4,
                tension: 0.4,
            })),
        });

        return (
            <div className="card rounded-main ">
                <div className="card-body">
                    <CheckData padding={0} data={this.state.data} loading={this.state.loading}>
                        <Timeline
                            chartSize="lg"
                            dontShowMetrics
                            metricType="primary"
                            data={this.state.data}
                            chartData={chartData}
                            forceRun={this.forceRun}
                            xAxisTitle={t('ai_tracking.keyword_detail.citation.platform')}
                            rightAxisLabel={t('ai_tracking.keyword_detail.citation.unique_urls')}
                            leftAxisLabel={t('ai_tracking.keyword_detail.citation.ai_checks')}
                            header={t('ai_tracking.keyword_detail.citation.citations_frequency')}
                            keys={keys(t)}
                            hasRightAxis
                            stackedX
                            customLegends
                            customChartSize={400}
                            customEmptyMessage={t('global.no_data')}
                        />
                    </CheckData>
                </div>
            </div>
        );
    }
}

export default withTranslation()(BlockCitation);
